const request = (method, endpoint, accessToken, data) => (
  fetch(`https://enterprise-apitest.cpg.org:443/d2/${endpoint}`, {
    method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: data ? JSON.stringify({
      data,
    }) : undefined,
  })
    .then((res) => res.json())
    .catch((error) => error.response)
)

export default {
  get: (endpoint, accessToken, data) => request('GET', endpoint, accessToken, data),
  post: (endpoint, accessToken, data) => request('POST', endpoint, accessToken, data),
  put: (endpoint, accessToken, data) => request('PUT', endpoint, accessToken, data),
  del: (endpoint, accessToken, data) => request('DELETE', endpoint, accessToken, data),
}
